@if (initialized && actions.length) {
  <form [formGroup]="inputForm">
    <div class="form-inputs">
      <!-- Render Dynamic form fields -->
      @for (formInput of formInputs; track formInput) {
        <mat-form-field>
          <mat-label>{{formInput.label || formInput.name}}</mat-label>
          @switch (formInput.type) {
            @case ('text') {
              <textarea matInput [formControlName]="formInput.name" [errorStateMatcher]="matcher">
              </textarea>
            }
          }
          @if (inputForm.controls[formInput.name].hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls[formInput.name].hasError('error')) {
            <mat-error>
              {{inputForm.controls[formInput.name].errors.error}}
            </mat-error>
          }
        </mat-form-field>
      }
      <!-- /Render Dynamic form fields -->
      <div class="form-actions">
        @for (action of actions; track action) {
          <button mat-flat-button [color]="action.options?.styles?.color"
          (click)="takeAction(action)">{{action.options?.label || action.state | titlecase}}</button>
        }
      </div>
    </div>
  </form>
}
